import ConfigCharts from '@/language/pt/components/config/ConfigCharts';
import ConfigContract from '@/language/pt/components/config/ConfigContract';
import ConfigModal from '@/language/pt/components/config/ConfigModal';
import ConfigStyle from '@/language/pt/components/config/ConfigStyle';
import ConfigUsers from '@/language/pt/components/config/ConfigUsers';
import IntegrationToken from '@/language/pt/components/config/IntegrationToken';

export default {
  ConfigCharts,
  ConfigContract,
  ConfigModal,
  ConfigStyle,
  ConfigUsers,
  IntegrationToken,
};
